import axios from '@/axios.js'

export default ({
  isRegistered: false,
  namespaced: true,
  state: {
    personas: [],
    persona: {}
  },
  actions: {
    getPersona ({commit}, personaId) {
      return new Promise((resolve, reject) => {
        axios.get(`/api/personas/${personaId}`)
          .then((response) => {
            commit('setPersonaMutation', response.data)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    getPersonas ({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('/api/personas')
          .then((response) => {
            commit('setPersonasMutation', response.data['hydra:member'])
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    addPersona ({ commit }, persona) {
      return new Promise((resolve, reject) => {
        axios.post('/api/personas', persona)
          .then((response) => {
            commit('addPersonaMutation', response)
            resolve(response)
          })
          .catch((error) => { 
            reject(error) 
          })
      })
    },
    updatePersona ({ commit }, persona) {
      return new Promise((resolve, reject) => {
        axios.patch(`/api/personas/${persona.id}`, persona, { headers: {'Content-Type': 'application/merge-patch+json'} })
          .then((response) => {
            commit('updatePersonaMutation', response.data)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    deletePersona ({ commit }, id) {
      return new Promise((resolve, reject) => {
        axios.delete(`/api/personas/${id}`)
          .then((response) => {
            commit('deletePersonaMutation', id)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    addDireccion (context, direccion) {
      return new Promise((resolve, reject) => {
        axios.post('/api/direccions', direccion)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => { 
            reject(error) 
          })
      })
    },
    updateDireccion (context, direccion) {
      return new Promise((resolve, reject) => {
        axios.patch(`/api/direccions/${direccion.id}`, direccion, { headers: {'Content-Type': 'application/merge-patch+json'} })
          .then((response) => {
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    emptyPersonas ({ commit }) {
      commit('emptyPersonasMutation')
    }
  },
  mutations: {
    setPersonaMutation (state, p) {
      state.persona = p
    },
    setPersonasMutation (state, p) {
      state.personas = p
    },
    addPersonaMutation (state, p) {
      state.personas.push(p)
    },
    updatePersonaMutation (state, persona) {
      const idx = state.personas.findIndex((u) => u.id === persona.id) // Buscamos o índice do elemento no array do state
      state.personas.splice(idx, 1, persona)
      state.persona = persona
    },
    deletePersonaMutation (state, id) {
      const idx = state.personas.findIndex((u) => u.id === id) // Buscamos o índice do elemento no array do state
      state.personas.splice(idx, 1)
    },
    emptyPersonasMutation (state) {
      // Vaciamos o store
      state.personas = []
    }
  },
  modules: {}
})